import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Richard Saul Wurman defined the concept of an ‘information
                                                architect’<a className="superscripttext"
                                                             href="further_info.php?course=300"><sup>2</sup></a> to
                                                describe someone who
                                                is amongst other things able to ‘organize the patterns
                                                inherent in data, making the complex clear’.
                                                Several reviews have shown that an abundance of this ability
                                                is key, especially in modern
                                                information-laden companies.</p>
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>There are always times when it’s difficult to break down a
                                                complex idea into simple parts that can
                                                be explained more easily. This tool is about<span
                                                    className="green brownbold"> How to make complex ideas simple, clear and
concise</span> and aims to help you understand how to break complex ideas down into simpler
                                                elements. The tool explores the impact of personal style on
                                                how you process complex information
                                                so you understand how others may prefer to use different
                                                formats from your own.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
COMPLEX THINKING
</span></div>
                                            <p>When Einstein first developed his theory of relativity, only
                                                a handful of people in the world could
                                                understand it. Now, 100 years later, nearly every physics
                                                undergraduate can.</p>
                                            <p>This seems strange, given that the ideas are as complex now
                                                as they were 100 years ago. The
                                                reason is that physicists have become better at explaining
                                                the theory and have had time to
                                                conduct practical experiments with it.</p>

                                            <p>Einstein stretched people’s minds well beyond contemporary
                                                thinking and, let’s face it, most of us
                                                aren’t Einsteins. However, we do have complex ideas we need
                                                to explain to others.</p>
                                            <p style={{paddingBottom: '11px ! important'}}>There are a number
                                                of contexts in which you may need to convey complex ideas.
                                                Here we will
                                                focus on the two most common:</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew uiheading lightbgcenter thought_ilead1">
                                                <ol className="blackOL ">
                                                    <li className="bold-li"><p className="spacing"><span
                                                        className="green brownbold">We have a new idea that we want to explain to others.</span>
                                                    </p><span>
<p className="spacing" style={{paddingBottom: '5px !important'}}>The people we need to explain an idea to have a similar range of experience or
knowledge as ourselves. For example, say you are working in marketing and have just
thought of an advertising concept for a product. In your own mind you can see the
concept, the images to go with it, the slogans, etc. The challenge is to convey this to your colleagues or a client in a way they can understand it.</p></span>
                                                    </li>
                                                </ol>
                                            </div>

                                            <div
                                                className="lightgreencontentbg keyquestionpadnew uiheading lightbgcenter">
                                                <ol className="blackOL paraspace" start="2">
                                                    <li className="bold-li"><p className="spacing"><span
                                                        className="green brownbold">We need to convey an idea to someone who is less knowledgeable about the issue.</span>
                                                    </p>
                                                        <span><p className="spacing">You have to explain complex processes to people who may have only a basic
understanding of the subject. For example, a business lecturer explaining the
complexities of the stock market to students. Basically, you have something in your
head that you need to get across to others, so, consider the following questions:</p></span>
                                                        <ul className="greenbullet-list lightbgcenter1">
                                                            <li><p
                                                                style={{paddingBottom: '0px !important'}}>Who
                                                                is my audience?</p></li>
                                                            <li><p
                                                                style={{paddingBottom: '0px !important'}}>Is
                                                                this on a 1:1 basis, in a small group or in
                                                                a large auditorium filled with people?</p>
                                                            </li>
                                                            <li className="cntareap"
                                                                style={{paddingBottom: '5px !important'}}><p
                                                                style={{paddingBottom: '0px !important'}}>What
                                                                method will I use to convey my thinking?
                                                                Verbal, Written, Graphical or a
                                                                combination of these methods?</p></li>
                                                        </ul>
                                                    </li>
                                                </ol>
                                            </div>

                                            <p className="paratop_lightbg">This tool helps you to identify
                                                what complex thinking looks like and how to communicate it
                                                simply,
                                                clearly and concisely.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}